/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Features_Layouts_DescInputs */

const en_cad_features_layouts_desc = /** @type {(inputs: Cad_Features_Layouts_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paper-space layouts with floating viewports, per-viewport layer overrides, page setups and scale-exact plotting to PDF. Export to SVG and PNG as well.`)
};

/**
* | output |
* | --- |
* | "Paper-space layouts with floating viewports, per-viewport layer overrides, page setups and scale-exact plotting to PDF. Export to SVG and PNG as well." |
*
* @param {Cad_Features_Layouts_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_features_layouts_desc = /** @type {((inputs?: Cad_Features_Layouts_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Features_Layouts_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_features_layouts_desc(inputs)
});
export { cad_features_layouts_desc as "cad.features.layouts_desc" }